import axios, { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { AuthenticationService } from './authentication.service';
import { Inject, Injectable } from '@angular/core';
import { HOST_CONFIG, HostConfig } from 'src/app/config/AppInitializer.factory';
import { environment } from 'src/environments/environment';
import { getValueIfPropertyExists } from 'src/app/utils/helper';

@Injectable({
  providedIn: 'root',
})
export class HttpClientService {
  private baseUrl = `${this.hostConfig.ebrApiUrl}/api/v2`;
  controller = new AbortController();


  constructor(
    private authenticationService: AuthenticationService,
    @Inject(HOST_CONFIG) private hostConfig: HostConfig) {}

  async get<T = any, R = AxiosResponse<T>, D = any>(
    path: string,
    responseType?: ResponseType
  ): Promise<R> {
    const url = `${this.baseUrl}${path}`;
    const options = await this.buildOptions(responseType);
    try{
      // axios's own R generic no longer accepts arbitrary pass-through types, so cast here
      const response = await axios.get<T, AxiosResponse<T>, D>(url, options);
      return response as unknown as R;
    }

    catch(error){
      throw error;
    }
  }

  async post<T = any, R = AxiosResponse<T>, D = any>(
    path: string,
    data?: D,
    responseType?: ResponseType,
  ): Promise<R> {
    const url = `${this.baseUrl}${path}`;
    const options = await this.buildOptions(responseType);
    const response = await axios.post<T, AxiosResponse<T>, D>(url, data, options);
    return response as unknown as R;
  }

  async delete<T = any, R = AxiosResponse<T>, D = any>(
    path: string
  ): Promise<R> {
    const url = `${this.baseUrl}${path}`;
    const options = await this.buildOptions();
    const response = await axios.delete<T, AxiosResponse<T>, D>(url, options);
    return response as unknown as R;
  }

  private async buildOptions(
    responseType?: ResponseType
  ): Promise<AxiosRequestConfig> {
    const onBehalfOf = this.authenticationService.onBehalfOf;
    const accessToken = await this.authenticationService.getAccessToken();
    const configurationKeyLabel: string | null = getValueIfPropertyExists<any, string | null>(environment, 'configurationKeyLabel', null);

    const headers = {
      ...{
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
      ...(onBehalfOf != null && {
        'On-Behalf-Of': onBehalfOf,
      }),
      ...(configurationKeyLabel != null && {
          'X-Configuration-Key-Label': configurationKeyLabel,
      }),
    };

    return {
      signal: this.controller.signal,
      headers: headers,
      ...(responseType != undefined &&
        responseType != null && {
          responseType: responseType,
        }),
    };
  }
}
